import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import { Box, Button, TextField, Select, MenuItem, CircularProgress } from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";
import swal from "sweetalert";
import Header from "../../../components/Header";
import { addFixedExpense, updateFixedExpense, fetchIntervals, fetchAccountSubCategory } from "../../../data/expensesData";
import { generateAndExecuteMutation, graphqlQuery } from "../../../data/Axios/DynamicService";
import { AccountsandFinanceurl, companyManagementUrl, salesManagement, userManagementUrl } from "../../../config";
//import { FixedExpenseFields } from "../../../data/DynamicTable/AccountsDynamicForms";
import DynamicForm from "../../../data/Axios/DynamicForm";
import { FixedExpenseFields } from "../../../data/DynamicTable/AccountsDynamicForms";
import { fetchJsonDynamic } from "../../../data/DynamicServiceNew/jsondynamicservice";


const base_url = companyManagementUrl.uri

const FixedExpenseForm = (props) => {
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const [intervals, setIntervals] = useState([]);
  const [accountSubcategories, setAccountSubcategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [Mappedbranches, setMappedBranches] = useState([]);
  const [branchIdData, setBranchIdData] = useState(null);
  const [branchoptionsInitialvalue, setBranchOptionsInitialValue] = useState(
    []
  );
    const [MappedFOs, setMappedFOs] = useState([]);
    const [FOData, setFOData] = useState([]);
    const [FOoptionsInitialvalue, setFOOptionsInitialValue] = useState([]);
    const [FOIdData, setFOIdData] = useState(null);
    const [regionData, setRegionData] = useState([]);
    const [branchData, setBranchData] = useState([]);
  const [formData, setFormData] = useState({
    id: props.data ? props.data.id : null,
    entry: props.data ? props.data.entry : "",
    amount: props.data ? props.data.amount : "",
    description: props.data ? props.data.description : "",
    intervalId: props.data ? props.data.intervalId : "",
    accountSubcategoryId: props.data ? props.data.accountSubcategoryId : "",
  });

  const userId = parseInt(decodedToken.Id);
  const companyId = parseInt(decodedToken.CompanyId);

  // Fetching intervals and account subcategories
  useEffect(() => {
    const fetchDropdownData = async () => {
      try {
        const intervalsData = await fetchIntervals();
        const accountSubcategoriesData =  await fetchJsonDynamic(
        "accountSubCategoryByCompany",
        null,
        null,
        AccountsandFinanceurl.uri
      );
      if (accountSubcategoriesData?.results) {
        const results = JSON.parse(accountSubcategoriesData?.results);
      
        // // Filter active subcategories
        // const UniqueSubcategories = results.filter(
        //   (subcategory) => subcategory.accountCategoryId === 2
        // );
        setAccountSubcategories(results);

      }

        setIntervals(intervalsData);
      } catch (error) {
        console.error("Error fetching dropdown data:", error);
      } finally {
        setLoading(false);  // Ensure loading is set to false after data fetching
      }
    };

    fetchDropdownData();
  }, []);
      useEffect(() => {
        async function fetchAllData() {
          try {
            const regionResponse = await fetchJsonDynamic(
              "region",
              null,
              null,
              base_url
            );
            if (regionResponse?.results) {
              const result = JSON.parse(regionResponse?.results);
              setRegionData(result || []);
            }
          } catch (error) {
            console.error("Error fetching data:", error);
          } finally {
            setLoading(false);
          }
        }
        fetchAllData();
      }, []);
    

  const initialValues = {
    id: props.data ? props.data.id : null,
    entry: props.data ? props.data.Entry : "",
    amount: props.data ? props.data.Amount : "",
    description: props.data ? props.data.Description : "",
    intervalId: props.data ? props.data.IntervalId : "",
    regionId: props.data ? props.data.RegionId : null,
    branchId: props.data ? props.data.BranchId : null,
    fieldOfficerId: props.data ? props.data.FieldOfficerId : null,
    accountSubCategoryId: props.data ? props.data.AccountSubCategoryId : "",
    executionDate: props.data ? props.data.ExecutionDate : null,
  };

  const validationSchema = yup.object().shape({
    entry: yup.string().required("Entry is required"),
    amount: yup.number().required("Amount is required").min(0, "Amount cannot be negative"),
    description: yup.string().required("Description is required"),
    intervalId: yup.string().required("Interval is required"),
    accountSubcategoryId: yup.string().required("Account Type is required"),
  });

  const fetchBranches = async (regionId) => {
       try {
         const params = { regionId: parseInt(regionId) };
   
         const businessDetails = await fetchJsonDynamic(
           "allBranchesByColumnValues",
           "branchModel",
           params,
           companyManagementUrl.uri
         );
         const allBranchDetails = JSON.parse(businessDetails?.results) || [];
   
         const branchOptions = allBranchDetails.map((role) => ({
           parent_key: role.Id,
           value: role.Id,
           label: role.Name,
         }));
   
         setMappedBranches(branchOptions || "");
         setBranchData(branchOptions || "");
   
         return branchOptions; // Return the mapped branch options
       } catch (error) {
         console.error("Error fetching branches:", error);
         return [];
       }
     };
      const fetchFieldOfficers = async (branchId) => {
             try {
               const params = { branchId: parseInt(branchId) };
         
               const FODetails = await fetchJsonDynamic(
                 "allUsersByColumnValues",
                 "usermodel",
                 params,
                 userManagementUrl.uri
               );
               const allFODetails = JSON.parse(FODetails?.results) || [];
         
               const FOOptions = allFODetails.map((officer) => ({
                 parent_key: officer.Id,
                 value: officer.Id,
                 label: officer.FirstName,
               }));
         
               setMappedFOs(FOOptions);
               setFOData(FOOptions);
         
               return FOOptions; // Return the mapped FO options
             } catch (error) {
               console.error("Error fetching Field Officers:", error);
               return [];
             }
           };
     const handleFieldChange = async (field, value) => {
      setFormData({ ...initialValues, [field.name]: value });
        if (field.name === "regionId") {
          const branchOptions = await fetchBranches(value);
          setBranchOptionsInitialValue(branchOptions || []); // Ensure an array is set
          setBranchData(branchOptions); // Set the branch data for further rendering in form
          // setBranchIdData(null); // Reset the branchId data if region changes
          return branchOptions;
        }
        if (field.name === "branchId") {
          const FOOptions = await fetchFieldOfficers(value);
          setFOOptionsInitialValue(FOOptions || []);
          setFOData(FOOptions);
          setFOIdData(null);
          return FOOptions;
        }
        if (field.name === "intervalId") {
  const selectedInterval = intervals.find(i => i.id === parseInt(value));
  if (selectedInterval) {
    const today = new Date();
    const nextDate = new Date(today);
    nextDate.setDate(today.getDate() + selectedInterval.interval);

    // Format to YYYY-MM-DD
    const formattedDate = nextDate.toISOString().split("T")[0];

    setFormData(prev => ({
      ...prev,
      [field.name]: value,
      executionDate: formattedDate,
    }));
  }
  return;
}

       
      };
      const regionOptions = regionData.map((status) => ({
        value: status.Id,
        label: status.Name,
      }));
      const tokenRoleGroupId = parseInt(decodedToken.RoleGroupId);
  const formFields =
    tokenRoleGroupId !== 5
      ? [
          {
            name: "regionId",
            label: "Region",
            type: "select",
            options: regionOptions,
            gridColumn: "span 2",
            required: true,
            parent: "main",
          },
          {
            name: "branchId",
            label: "Branch",
            type: "select",
            options: Mappedbranches || null,
            gridColumn: "span 2",
            required: true,
            parent: "dependent",
            dependentOn: "regionId",
          },
          {
            name: "fieldOfficerId",
            label: "Field Officer",
            type: "select",
            options: MappedFOs,
            gridColumn: "span 2",
            required: false,
            parent: "subdependent", // Dependent on branchId
            dependentOn: "branchId",
            subparent: "branchId", // Indicates a subparent
          },
        ]
      : [];

  const fields = [
    ...FixedExpenseFields,
    {
      name: "intervalId",
      label: "Interval",
      type: "select",
      gridColumn: "span 2",
      required: true,
      options: intervals.map((interval) => ({
        value: interval.id,
        label: interval.intervalName,
      })),
    },
    {
  name: "executionDate",
  label: "Start Date",
  type: "date",
  gridColumn: "span 2",
  required: true
},

    {
      name: "accountSubCategoryId",
      label: "Expense Type",
      type: "select",
      gridColumn: "span 2",
      required: true,
      options: accountSubcategories.map((subcategory) => ({
        value: subcategory.Id,
        label: subcategory.AccountName,
      })),
    },
    ...formFields
  ];

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const { 
        entry,
        amount,  
        description, 
        intervalId,
        regionId,
        branchId,  
        fieldOfficerId,
        accountSubCategoryId ,
        executionDate
      } = values;

      const mutationData = props.isEditing
        ? {
            id: props.data.Id,
            entry,
            amount: parseFloat(amount),
            description,
            intervalId,
            executionDate,
            regionId:
            tokenRoleGroupId !== 5
              ? regionId
              : parseInt(decodedToken.RegionId),
            branchId:
              tokenRoleGroupId !== 5
                ? branchId
                : parseInt(decodedToken.BranchId),
            fieldOfficerId:
              tokenRoleGroupId !== 5
                ? fieldOfficerId
                : parseInt(decodedToken.Id),
            accountSubCategoryId,
            updatedBy: userId,
          }
        : {
            entry,
            amount: parseFloat(amount),
            description,
            intervalId,
            executionDate,
            regionId:
            tokenRoleGroupId !== 5
              ? regionId
              : parseInt(decodedToken.RegionId),
            branchId:
            tokenRoleGroupId !== 5
              ? branchId
              : parseInt(decodedToken.BranchId),
            fieldOfficerId:
              tokenRoleGroupId !== 5
                ? fieldOfficerId
                : parseInt(decodedToken.Id),
            accountSubCategoryId,
            createdBy: userId,
          };

      const response = await generateAndExecuteMutation(
        props.isEditing ? "updateFixedEntries" : "createFixedEntries",
        mutationData,
        "fixedEntries",
        base_url
      );

      if (Object.values(response)[0] != null) {
        props.onClose();
        props.onAction();
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: `Fixed Expense ${
            props.isEditing ? "updated" : "created"
          } successfully.`,
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "An error occurred while processing your request. Please try again later.",
      });
    }

    setSubmitting(false);
  };

  if (loading) {
    return <div className="justify-content-center"><CircularProgress /></div>; // Use CircularProgress for better UX
  }

  return (
    <>
    <DynamicForm
      initialValues={initialValues}
      fields={fields}
      onFieldChange={handleFieldChange}
      onSubmit={handleSubmit}
      title={props.isEditing ? "Edit Fixed Expense" : "Create Fixed Expense"}
      subtitle={props.isEditing ? "Edit an existing fixed expense" : "Create new fixed expense"}
    />
    </>
  );
};

export default FixedExpenseForm;
